import React from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", key: "home" },
  { to: "/services", label: "Services", key: "services" },
  { to: "/products", label: "Products", key: "products" },
  { to: "/about", label: "About", key: "about" },
  { to: "/team", label: "Team", key: "team" },
  { to: "/careers", label: "Careers", key: "careers" },
  { to: "/contact", label: "Contact", key: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="container-wide flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-3 group">
          <img src="/skyverra-logo.png" alt="Skyverra" className="h-8 md:h-10 w-auto transition-transform group-hover:scale-105 duration-200" />
          <div className="leading-tight">
            <div className="font-display font-bold text-[15px] md:text-[17px] text-[color:var(--sky-ink)] tracking-tight">Skyverra</div>
            <div className="overline text-[9px] md:text-[10px]">Consulting</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.key}
              to={l.to}
              data-testid={NAV[l.key]}
              className={({ isActive }) =>
                `text-sm font-medium tracking-tight link-underline transition-colors duration-200 ${
                  isActive ? "text-[color:var(--sky-navy)]" : "text-[color:var(--sky-muted)] hover:text-[color:var(--sky-ink)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link to="/contact" data-testid={NAV.ctaContact} className="btn-primary text-sm">
            Talk to us
          </Link>
        </div>

        <button
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded border border-[color:var(--sky-border)]"
          onClick={() => setOpen((v) => !v)}
          data-testid={NAV.mobileToggle}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[color:var(--sky-border)] bg-white">
          <div className="container-wide py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.key}
                to={l.to}
                data-testid={`${NAV[l.key]}-mobile`}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-[color:var(--sky-navy)]" : "text-[color:var(--sky-muted)]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-primary text-sm mt-2 w-fit">Talk to us</Link>
          </div>
        </div>
      )}
    </header>
  );
}
